; (function () {
    var

        _$wrapper = null,


        //set to true when a popup is open, can't open another
        _popup_open = false,



        //
        // init 
        //
        init = function () {
            _$wrapper = $('.layout-template-list');

            if (_$wrapper.length > 0) {

                disableEnterKey();
                setupAddTemplate();
                setupCopyTemplate();
                setupDeleteTemplate();
                setupRenameTemplate();
            }
        },

        disableEnterKey = function () {
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            });
        },

        //
        // setup the add template button
        //
        setupAddTemplate = function () {
            $('#lnkAddTemplate').on('click', function () {
                $('#lnkAddTemplate .icon').toggleClass('icon-plus').toggleClass('icon-spinner');
    
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/Template/New',
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Add Template',
                                content: html,
                                afterOpen: function ($popup) {
                                    _popup_open = false;
                                    $('#lnkAddTemplate .icon').toggleClass('icon-plus').toggleClass('icon-spinner');
                    
                                    setupImageExpand($popup);
                                    setupTemplateSelect($popup);
                                    $popup.find("[data-btn-type='ok']").prop('disabled', true);
                                },
                                okButtonText: "Save",
                                css: 'modal-lg',
                                okCallback: function ($popup) {
                                    $popup.find("[data-btn-type='ok']").before('<i class="fa-regular fa-spinner fa-spin fs-3 mr10"></i>');
                                    var formData = new FormData();
                                    var title = $popup.find('#TemplateTitle').val().trim();
                                    formData.append('templateTitle', title);
                                    var templateID = $popup.find('input[name="TemplateID"]:checked').val();
                                    formData.append('templateID', templateID);
    
                                    delta.ajax.postFormData(
                                        '/Template/New',
                                        formData,
                                        function (result) {
                                            //close the popup
                                            delta.popup.close($popup);
    
                                            //redirect
                                            window.location.href = "/Template/Edit?templateID=" + result.templateID + "&" + delta.pageParams.getPageParams();
                                        }
                                    );

                                    return false;
                                }
                            });

                        }
                    );
                }
            });
        },


        //
        // setup template selection - adds border to image when clicked, enable/disable save button
        //
        setupTemplateSelect = function ($popup) {
            $popup.find('.template-select').on('change', function () {
                validateSave($popup);
            });
            $popup.find('#TemplateTitle').on('keyup', function () {
                validateSave($popup);
            });
            $('.template-select').on('change', function () {
                $('.thumbnail').removeClass('selected-image');
                if ($(this).is(':checked')) {
                    $(this).closest('.col').find('.thumbnail').addClass('selected-image');
                }
            });
        },

        // enable/disable save button
        validateSave = function ($popup) {
            var hasTitle = $popup.find('#TemplateTitle').val().trim() != "";
            var templateSelected = $popup.find('input[name="TemplateID"]:checked').length > 0;
            var saveValid = hasTitle && templateSelected;
            var saveBtn = $popup.find("[data-btn-type='ok']");
            saveBtn.prop('disabled', !saveValid);

        }



        //
        // setup template image expand
        //
        setupImageExpand = function ($popup) {
            $popup.find('.img-lnk').on('click', function (event) {
                event.preventDefault();
                var imgSrc = $(this).find('img').attr('src');
                var title = $(this).find('img').attr('alt');
                var html = `<div class='text-center'><img src="${imgSrc}"></div>`
                delta.popup.open({
                    type: 'alert',
                    title: title,
                    content: html,
                    css: 'modal-xl'
                });
            });
        }



        //
        // copy a template
        //
        setupCopyTemplate = function () {
            _$wrapper.on('click', '.lnk-copy', function () {
                var $a = $(this);
                var templateID = $a.attr('data-template-id');
                var title = $a.closest('tr').find('td').eq(0).find('a').text();

                delta.popup.open({
                    type: 'confirm',
                    title: 'Copy Template',
                    content: '<p>This will create a copy of the <b>' + title + '</b> Template.</p><div class="mb-3"><label for="txtNewTemplateName" class="col-form-label">New Template Name</label><input type="text" id="txtNewTemplateName" class="form-control"/></div>',
                    okButtonText: 'Create Copy',
                    afterOpen: function($popup) {
                        //get the copy button & disable it
                        var $btn = $popup.find('.modal-footer').find('button.btn-primary');
                        $btn.prop('disabled', true);

                        //get the input, set focus & hookup handler
                        var $txt = $popup.find('#txtNewTemplateName');

                        $popup.on('shown.bs.modal', function() {
                            $txt.focus();
                        });
                        
                        $txt.on('input paste cut change keyup', function() {
                            if ($txt.val().trim() === "") {
                                $btn.prop('disabled', true);
                            } else {
                                $btn.prop('disabled', false);
                            }
                        });
                    },
                    okCallback: function($popup) {
                        $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                        var $txt = $popup.find('#txtNewTemplateName');
                        var txt = encodeURIComponent($txt.val());

                        delta.ajax.get(
                            '/template/copy?templateID=' + templateID + '&name=' + txt,
                            function(result) {
                                //redirect
                                window.location.href = "/Template/Edit?templateID=" + result.templateID + "&" + delta.pageParams.getPageParams();
                            }
                        );
                        return false;
                    }
                });

                return false;
            });

        },


        //
        // delete a template
        //
        setupDeleteTemplate = function () {
            _$wrapper.on('click', '.lnk-delete', function () {
                var $a = $(this);
                var templateID = $a.attr('data-template-id');
                var tableRow = $a.closest('tr');
                var title = tableRow.find('td').eq(0).find('span').text();

                delta.popup.open({
                    type: 'confirm',
                    title: 'Delete Template',
                    content: 'Are you sure you want to delete the <b>' + title + '</b>  template?',
                    okButtonText: 'Delete Template',
                    okCallback: function ($popup) {
                        $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
                        delta.ajax.get(
                            '/template/delete?templateID=' + templateID,
                            function (html) {
                                document.location.reload();
                            }
                        );

                        return false;
                    }
                });

                return false;
            });

        },

  

        setupRenameTemplate = function () {

            $(document).on('shown.bs.modal', '.modal-template-rename', function () {
                const $renameBtn = $(".modal-template-rename button[data-btn-index='1']");
                    $($renameBtn).prop("disabled", true);

                const input = document.getElementById("Title");
                input.focus();
                input.select();

                $("#Title").on("input paste cut change keyup", function () {
                        if ($('#Title').val().trim() === "") {
                            $($renameBtn).prop("disabled", true);
                        } else {
                            $($renameBtn).prop("disabled", false);
                        }
                    });
                });

            _$wrapper.on('click', '.lnk-rename', function () {

                    if (!_popup_open) {
                        _popup_open = true;
                        var $a = $(this);
                        var templateID = $a.attr('data-template-id');
                        delta.ajax.get(
                            '/Template/TemplateRenamePopup?templateID=' + templateID,
                            function (html) {
                                delta.popup.open({
                                    type: 'confirm',
                                    title: 'Rename Template',
                                    content: html,
                                    cssClass: 'modal-template-rename',
                                    okButtonText: 'Save',
                                    afterOpen: function () {
                                        _popup_open = false;
                                    },
                                    okCallback: function ($popup) {
                                        $('.required-label').remove();
                                        if ($('#Title').val().trim() === "") {
                                            $('#Title').after('<label class="required-label text-danger mt-1">Template name is required</label>');
                                            $('#Title').trigger('focus');
                                            delta.popup.enableButtons($popup);
                                        } else {

                                            $('#autoPopup_1 .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
                                            var formData = new FormData();
                                            $popup.find('.modal-body').find('input[type="text"], input[type="hidden"]').each(function () {
                                                var $elem = $(this);
                                                var name = $elem.attr('name');
                                                formData.append(name, $elem.val());
                                            });

                                            delta.ajax.postFormData(
                                                '/template/rename',
                                                formData,
                                                function (result) {
                                                    if (result.isValid) {
                                                        //close the popup
                                                        $('.modal-newreport-wizard .modal-footer .fa-spinner').remove();
                                                        delta.popup.close($popup);

                                                        //redirect
                                                        window.location = result.url;
                                                    } else {
                                                        $('.modal-newreport-wizard  .modal-footer .fa-spinner').remove();
                                                        $popup.find('.modal-body').html(`<h2 class="text-danger">${result.message}</h2>`);
                                                        delta.popup.enableButtons($popup);
                                                    }
                                                }
                                            );
                                        }
                                        delta.popup.enableButtons($popup);
                                        return false;
                                    }
                                });
                            }
                        );
                    }
                    return false;
                });
            },



        dummy = function () { };

    $(document).ready(init);

}());







